export default __webpack_public_path__ + "typescript.7c765eb5.png";